module.exports = {
  inputBlockWrap: 'rhfa-inputBlockWrap',
  label: 'rhfa-label',
  input: 'rhfa-input',
  standard: 'rhfa-standard',
  errored: 'rhfa-errored',
  inlineWrap: 'rhfa-inlineWrap',
  itemHeader: 'rhfa-itemHeader',
  button: 'rhfa-button',
  checkboxWrap: 'rhfa-checkboxWrap',
  radioGroupWrap: 'rhfa-radioGroupWrap',
  checkboxLabel: 'rhfa-checkboxLabel',
  radioLabel: 'rhfa-radioLabel',
  inputPanelWrap: 'rhfa-inputPanelWrap',
  error: 'rhfa-error',
  select: 'rhfa-select',
  table: 'rhfa-table',
  panel: 'rhfa-panel',
  title: 'rhfa-title',
  content: 'rhfa-content',
  contentMargin: 'rhfa-contentMargin'
}
